export default __webpack_public_path__ + "static/media/facebook.6c9870ba.svg";